var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"procedures"},[_c('procedures-page',{attrs:{"object":"conclusion"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }